import { makeStyles } from '@material-ui/core/styles';
import SubmenuLink from 'src/components/UI/SubmenuLink';
import { useEffect, useState } from 'react';
import { getTaxesAction } from 'src/redux/actions/taxActions';
import OrganisationAddressForm from 'src/components/Forms/OrganisationAddressForm';
import OrganisationImagesForm from 'src/components/Forms/OrganisationImagesForm';
import OrganisationEmailsForm from 'src/components/Forms/OrganisationEmailsForm';
import ManageOrganisationTaxes from 'src/components/Elements/ManageOrganisationTaxes';
import OrganisationInfo from 'src/components/Forms/OrganisationInfo';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import ManageBankAccounts from 'src/components/Elements/ManageBankAccounts';
import { getSettingsAction } from 'src/redux/actions/settingActions';

const useStyles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    alignItems: 'bottom',
    height: '4vh',
    gap: '10px',
  },
  header: {
    paddingLeft: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
}));

export const enum TABS {
  general = 'general',
  payment = 'payment',
  address = 'address',
  email = 'email',
  images = 'images',
  taxes = 'taxes',
}

const SettingsPage = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();

  const [currentTab, setCurrentTab] = useState(TABS.general);
  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  useEffect(() => {
    dispatch(getTaxesAction());
    dispatch(getSettingsAction());
  }, []);

  const renderForm = () => {
    switch (currentTab) {
      case TABS.payment:
        return (<ManageBankAccounts />);
      case TABS.address:
        return (<OrganisationAddressForm />);
      case TABS.images:
        return (<OrganisationImagesForm />);
      case TABS.email:
        return (<OrganisationEmailsForm />);
      case TABS.taxes:
        return (<ManageOrganisationTaxes />);
      default:
        return (<OrganisationInfo />);
    }
  };

  return (
    <div>
      <div className={`${classes.row} ${classes.header}`}>
        <SubmenuLink
          onClick={() => setCurrentTab(TABS.general)}
          selected={currentTab === TABS.general}
          testId="settings-submenulink-general-information"
          noMargin>
          <span>{t(lang, 'misc.general_information')}</span>
        </SubmenuLink>
        <SubmenuLink
          onClick={() => setCurrentTab(TABS.address)}
          selected={currentTab === TABS.address}
          testId="settings-submenulink-address"
          noMargin>
          <span>{t(lang, 'misc.address_information')}</span>
        </SubmenuLink>
        <SubmenuLink
          onClick={() => setCurrentTab(TABS.payment)}
          selected={currentTab === TABS.payment}
          testId="settings-submenulink-payment"
          noMargin>
          <span>{t(lang, 'misc.bank_account')}</span>
        </SubmenuLink>
        <SubmenuLink
          onClick={() => setCurrentTab(TABS.taxes)}
          testId="settings-submenulink-taxes"
          selected={currentTab === TABS.taxes}
          noMargin>
          <span>Taxes</span>
        </SubmenuLink>
        <SubmenuLink
          onClick={() => setCurrentTab(TABS.email)}
          testId="settings-submenulink-email"
          selected={currentTab === TABS.email}
          noMargin>
          <span>Emails</span>
        </SubmenuLink>
        <SubmenuLink
          onClick={() => setCurrentTab(TABS.images)}
          testId="settings-submenulink-images"
          selected={currentTab === TABS.images}
          noMargin>
          <span>Images</span>
        </SubmenuLink>
      </div>
      <div>
        { renderForm() }
      </div>
    </div>
  );
};

export default SettingsPage;
